import { ProductTransportType } from '@shared/api/types';
import Text from '@shared/components/content/text';
import Unit from '@shared/components/content/unit';
import { EmissionBarCell } from '@shared/components/data-table/cells/emission-bar-cell';
import { HeaderCell } from '@shared/components/data-table/cells/header-cell';
import { NumberCell } from '@shared/components/data-table/cells/number-cell';
import { ColumnDef } from '@tanstack/react-table';

export function useProductTransportTableColumns(
  maxEmissions: number
): ColumnDef<ProductTransportType>[] {
  return [
    {
      id: 'step',
      accessorKey: 'name',
      size: 170,
      minSize: 170,
      maxSize: 170,
      header: ({ column }) => <HeaderCell column={column} name="Step" />,
      cell: ({ getValue }) => {
        const name = getValue<string>();
        return (
          <Text includeHover className="block w-full truncate">
            {name}
          </Text>
        );
      },
    },
    {
      id: 'spacer',
      header: () => null,
      cell: () => null,
      size: 70,
      minSize: 70,
      maxSize: 70,
      enableSorting: false,
    },
    {
      id: 'emissions',
      accessorKey: 'totalEmissionsPerItem',
      size: 80,
      minSize: 80,
      header: ({ column }) => (
        <HeaderCell
          column={column}
          name="Emissions"
          numberColumn
          unit={<Unit variant="kgCO2e" />}
        />
      ),
      cell: ({ getValue }) => {
        const emissions = parseFloat(getValue<string>());
        return <NumberCell number={emissions} />;
      },
    },
    {
      id: 'bar',
      accessorKey: 'totalEmissionsPerItem',
      header: () => <div className="w-full" />,
      size: 130,
      enableSorting: false,
      cell: ({ row }) => {
        const emissions = parseFloat(row.original.totalEmissionsPerItem);
        return (
          <EmissionBarCell
            type="transport"
            emissions={emissions}
            maxEmissions={maxEmissions}
            className="w-full pr-2"
            showHover={false}
          />
        );
      },
    },
  ];
}
